module.exports = {
      id: "environment-usage",
      viewBox: "0 0 28.781 28.787",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#environment",
      toString: function () {
        return this.url;
      }
    }